module.exports = __webpack_public_path__ + "static/poland-1cce0f3fc387c893cf8ba315fc93a520.jpeg";